export default function StatsSection() {
  const stats = [
    { value: '500万+', label: '注册用户' },
    { value: '10万+', label: '爆料文章' },
    { value: '1亿+', label: '累计阅读' },
    { value: '99%', label: '用户好评' },
  ];

  return (
    <section className="w-full bg-secondary-100 py-16 md:py-24 px-4 md:px-8" aria-label="平台数据">
      <div className="max-w-6xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-xs font-medium mb-6">
          平台实力
        </span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-500 leading-tight mb-10 md:mb-14">
          全网领先的
          <br />
          吃瓜爆料平台
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center lg:text-left">
              <p className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-800 font-heading">
                {stat.value}
              </p>
              <p className="mt-1.5 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm text-foreground-600">
          <p>实时更新全网热点爆料</p>
          <p>严格审核确保内容真实</p>
          <p>智能推荐精准匹配兴趣</p>
          <p>社区互动分享吃瓜心得</p>
        </div>
      </div>
    </section>
  );
}